// extracted by mini-css-extract-plugin
export default {"swatch-active":"ColorSwatches_swatch-active__CXBbh","swatch":"ColorSwatches_swatch__iP4PK","swatch-img":"ColorSwatches_swatch-img__mfrHn"};